import React from "react";
import { SITE } from "../data/siteData";

export default function Support({ style = {} }) {
  return (
    <p
      style={{
        fontSize: 12,
        color: "#64748b",
        textAlign: "center",
        lineHeight: 1.7,
        marginTop: 16,
        ...style,
      }}
    >
      If you encounter any issues, call or WhatsApp{" "}
      <a href={`tel:${SITE.supportPhone}`} style={{ color: "#0ea5e9" }}>
        {SITE.supportPhone}
      </a>{" "}
      or email{" "}
      <a href={`mailto:${SITE.supportEmail}`} style={{ color: "#0ea5e9" }}>
        {SITE.supportEmail}
      </a>
    </p>
  );
}
